import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsProtect1InV4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30 33L30 63L0 63" stroke="#FFDD00" strokeWidth="2" />
      <path d="M63 31V1H33" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
